import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { useSchedulingChartsDataContext } from './hooks/useSchedulingChartsDataContext';

export const Indicators = () => {
    const { chartData } = useSchedulingChartsDataContext();

    return (
        <div
            className="w-100"
            style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}
        >
            <Card
                title="Agendamentos"
                value={number.formatToBRNumber(
                    chartData?.indicators?.allAppointments || 0
                )}
            />
            <Card
                title="Atendimentos"
                value={number.formatToBRNumber(
                    chartData?.indicators?.appointmentsMade || 0
                )}
            />
            <Card
                title="Percentual de Atendimentos"
                value={
                    (
                        ((Number(chartData?.indicators?.appointmentsMade || 0) /
                            Number(
                                chartData?.indicators?.allAppointments || 1
                            )) *
                        100) || 0
                    ).toFixed(2) + '%'
                }
            />
            <Card
                title="Saldo"
                value={number.formatToBRNumber(
                    chartData?.indicators?.appointmentsBalance || 0
                )}
            />
        </div>
    );
};
